import { useEffect, useState } from "react";

import { TOUCH_COLLECTION_MEDIA_QUERY } from "./responsive";

export type ViewMode = "cubes" | "rectangles" | "list";

function storageKey(key: string) {
  return `manutio:view-mode:${key}`;
}

function readStoredMode(key: string): ViewMode | null {
  let saved: string | null;
  try {
    saved = window.localStorage.getItem(storageKey(key));
  } catch {
    return null;
  }

  if (saved === "cards") {
    try {
      window.localStorage.setItem(storageKey(key), "rectangles");
    } catch {
      // La preferenza migrata resta valida anche quando non può essere riscritta.
    }
    return "rectangles";
  }

  return saved === "cubes" || saved === "rectangles" || saved === "list" ? saved : null;
}

function defaultMode(): ViewMode {
  return window.matchMedia(TOUCH_COLLECTION_MEDIA_QUERY).matches ? "rectangles" : "list";
}

export function useViewMode(key: string) {
  const [hasPreference, setHasPreference] = useState(() => readStoredMode(key) !== null);
  const [mode, setMode] = useState<ViewMode>(() => readStoredMode(key) ?? defaultMode());

  useEffect(() => {
    if (hasPreference) return;

    const media = window.matchMedia(TOUCH_COLLECTION_MEDIA_QUERY);
    const updateDefault = (event: MediaQueryListEvent) => setMode(event.matches ? "rectangles" : "list");
    media.addEventListener("change", updateDefault);

    return () => media.removeEventListener("change", updateDefault);
  }, [hasPreference]);

  function chooseMode(nextMode: ViewMode) {
    try {
      window.localStorage.setItem(storageKey(key), nextMode);
    } catch {
      // La scelta resta attiva per la sessione anche quando lo storage è bloccato.
    }
    setHasPreference(true);
    setMode(nextMode);
  }

  return [mode, chooseMode] as const;
}
